



















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { DxPopup, DxButton, DxTextBox, DxScrollView } from 'devextreme-vue';
import { DxHtmlEditor, DxItem, DxToolbar } from 'devextreme-vue/html-editor';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { Prop } from 'vue-property-decorator';
import { DxResponsiveBox, DxLocation, DxCol, DxRow } from 'devextreme-vue/responsive-box';
import { FeeSheetRowDto, FeeSheetRowTypeEnum } from '@/models/Fees/FeeSheetRowDto';
import DxValidator, { DxRequiredRule  as RequiredRule} from 'devextreme-vue/validator';
import { DxForm } from 'devextreme-vue/form';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { FeeSheetsService}  from '@/service/FeeSheetsService';
import CommonModule from '@questelservices/common';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';

@Component({
  components: {
    DxPopup,
    DxHtmlEditor,
    DxItem,
    DxToolbarItem,
    DxResponsiveBox,
    DxLocation,
    DxCol,
    DxRow,
    DxToolbar,
    DxButton,
    DxTextBox,
    DxValidator,
    RequiredRule,
    DxForm,
    DxScrollView
  }
})
export default class FeeSheetRowNotes extends Vue {
  
    feeSheetService: FeeSheetsService;
    commonState = getModule(CommonModule, store);

    constructor() {
        super();
        this.feeSheetService = new FeeSheetsService('/api/FeeSheets');
    }

    @Prop()
    feeSheetRowId!: string | null

    @Prop()
    notes!: string | null

    @Prop()
    title!: string | null

    @Prop()
    updatedBy!: string | null
    
    @Prop()
    updateDate!: Date | null

    @Prop()
    showDialog!: boolean

    private defaultGuidValue: string = "00000000-0000-0000-0000-000000000000";
    private actualNotesValue: string | null = "";

    get showingDialog(): boolean {
        return this.showDialog;
    }

    set showingDialog(value: boolean) {
        this.actualNotesValue = null;
        this.$emit("update:showDialog", value);
    }

    save(e:any) {
        if(this.feeSheetRowId && this.feeSheetRowId != this.defaultGuidValue) {
            this.feeSheetService.updateFeeSheetRowNotes(this.feeSheetRowId, this.actualNotesValue)
            .then(x=> {
                if(x.Success) {
                    notify("Notes updated", "success", 500);
                    this.$emit('update:notes', this.actualNotesValue);
                    this.$emit('update:updatedBy', this.commonState.jwtData.Name);
                    this.$emit('update:updateDate', new Date());
                    this.showingDialog=false;
                }
                else {
                    notify("Notes not updated", "error", 500);
                }
            })
            .catch(x=> {
                notify("Notes not updated", "error", 500);
            })
        }
        else {
            if(this.actualNotesValue && this.actualNotesValue.trim()) {
                this.$emit('update:notes', this.actualNotesValue);
                this.$emit('update:updatedBy', this.commonState.jwtData.Name);
                this.$emit('update:updateDate', new Date());
            }
            else {
                this.$emit('update:notes', null);
                this.$emit('update:updatedBy', null);
                this.$emit('update:updateDate', null);
            }
            notify("Notes updated", "success", 500);
            this.showingDialog=false;
        }
        
    }

    private cancel(): void {
        this.$emit("update:showDialog", false);
    }

    get lastUpdate() {
        let name: string = "";
        let dateFormat: string ="";

        if(this.updatedBy && this.updatedBy.trim()) {
            name = `Last update: ${this.updatedBy}`;
        }

        if(this.updateDate) {
            dateFormat =  `${moment(this.updateDate).format("MMM D, YYYY")}`;
        }
        return `${name} ${dateFormat}`
    }

    private onShowing() {
        this.actualNotesValue = this.notes;
    }

    screen(width: number) {
        if(width < 640)
        return 'xs';
        else 
        return 'sm';
    }

}
